import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgFormGroupModule, TgGridModule } from '@trademe/tangram';
import { MotorsListingDetailsContactSectionModule } from 'libs/motors-ui/src/lib/sections/motors-listing-details-contact-section/motors-listing-details-contact-section.module';
import { MotorsListingDetailsFieldSectionModule } from 'libs/motors-ui/src/lib/sections/motors-listing-details-field-section/motors-listing-details-field-section.module';
import { MotorsListingDetailsHeaderSectionModule } from 'libs/motors-ui/src/lib/sections/motors-listing-details-header-section/motors-listing-details-header-section.module';
import { MotorsListingDetailsPackageSectionModule } from 'libs/motors-ui/src/lib/sections/motors-listing-details-package-section/motors-listing-details-package-section.module';
import { MotorsVehicleDetailsHeaderSectionModule } from 'libs/motors-ui/src/lib/sections/motors-vehicle-details-header-section/motors-vehicle-details-header-section.module';
import { TmDateComponent } from 'libs/trademe-core-ui/src/lib/tm-date/tm-date.component';
import { BoatsAndMarineListingDetailsPageComponent } from './motors-listing-details-page.component';
import { MotorsListingDetailsSectionModule } from 'libs/motors-ui/src/lib/sections/listing-details/motors-listing-details.module';
import { FormsModule } from '@angular/forms';
import { MotorsCannotEditSomethingMessageSectionModule } from 'libs/motors-ui/src/lib/sections/motors-cannot-edit-something-message-section/motors-cannot-edit-something-message-section.module';

@NgModule({
    imports: [
        CommonModule,
        TgGridModule,
        MotorsListingDetailsHeaderSectionModule,
        MotorsListingDetailsFieldSectionModule,
        MotorsListingDetailsContactSectionModule,
        MotorsListingDetailsPackageSectionModule,
        FormsModule,
        TgFormGroupModule,
        MotorsVehicleDetailsHeaderSectionModule,
        MotorsListingDetailsSectionModule,
        MotorsCannotEditSomethingMessageSectionModule
    ],
    declarations: [BoatsAndMarineListingDetailsPageComponent],
    providers: [TmDateComponent],
    exports: [BoatsAndMarineListingDetailsPageComponent]
})
export class BoatsAndMarineListingDetailsPageModule { }
